// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.epigram-home {\n  color: #D4AF37;\n  font-size: 1.25em;\n  text-shadow: 3px 3px rgba(0, 0, 0, 0.2);\n}\n", ""]);
// Exports
module.exports = exports;
